import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { searchModel } from '../../models/search-model';
import { SearchResponseModel } from '../../models/search-response-model';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public url = `${environment.urlBase}/search/`;
  public search: searchModel;

  constructor(private http: HttpClient) {
    this.search = {
      query: '',
      user: null,
      tipo: ['REPORT', 'BOARD', 'FILE_KNOWLEDGE_BANK'],
      topK: 10
    };
  }

  searchInfo(dto: string): Observable<SearchResponseModel> {
    this.search.query = dto;
    return this.http.post<SearchResponseModel>(this.url, this.search);
  }
}
